import React, { useState, useEffect } from "react";
import Select from 'react-select';
import { connect } from 'react-redux';
import _ from 'lodash';
import DatePicker from 'react-datepicker';
import { DateInputFormat } from "../common/DateComponents";
import { format, setHours, setMinutes, setSeconds, subYears, addYears } from 'date-fns'
import { Actions as LEAVEADJUSTMENTACTIONS } from '../../store/actions/leaveAdjustmentActions';
import { XMarkIcon } from '@heroicons/react/20/solid'
import Spinner from "../common/Spinner";


const LeaveAdjustmentModal = ({
    leaveTypeOptions,
    setOpenLeaveAdjustmentModal,
    saveLeaveAdjustments,
    modalAdjustmentState,
    employeeOptions,
    typeOptions,
    modalAdjustmentLeave,
    isSaving
}) => {

    const today = new Date();

    const [hours, setHoursWorked] = useState(0);

    const [timeIn, setTimeIn] = useState(setHours(setMinutes(setSeconds(today, 0), 0), 9));

    const [employee, setEmployee] = useState(employeeOptions && employeeOptions[0]);

    const [leaveType, setLeaveType] = useState({ value: 6020, label: "Vacation" });

    const [type, setType] = useState(typeOptions && typeOptions[0]);

    const [comment, setComment] = useState("");

    const [leaveDate, setLeaveDate] = useState(new Date());

    useEffect(() => {
        if (modalAdjustmentLeave) {
            setEmployee(employeeOptions && employeeOptions.find(e => e.value == modalAdjustmentLeave.agreementId))
            setHoursWorked(modalAdjustmentLeave.hours)
            setLeaveType(leaveTypeOptions && leaveTypeOptions.find(t => t.value == modalAdjustmentLeave.leaveType))
            setType(typeOptions && typeOptions.find(t => t.value == modalAdjustmentLeave.adjustmentType))
            setLeaveDate(new Date(modalAdjustmentLeave.date))
            setComment(modalAdjustmentLeave.comment)
        }
    }, [modalAdjustmentLeave]);

    if (!modalAdjustmentState) {
        return null
    }

    const saveLeaveData = () => {
        const leaveData = {
            ...modalAdjustmentLeave,
            'agreementId': employee && employee.value,
            'hours': parseFloat(hours) || 0,
            'adjustmentType': type && type.value,
            'leaveType': leaveType && leaveType.value,
            'date': `${format(leaveDate, "yyyy-MM-dd")} ${format(timeIn, "HH:mm")}`,
            'comment': comment || [],
        }
        console.log("leaveData", leaveData)
        saveLeaveAdjustments(leaveData);
    }

    return (
        <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "scroll" }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="block block-themed block-transparent remove-margin-b" style={{ padding: 0 }}>
                        <div className="block-header bg-primary-dark" style={{ padding: 20 }}>
                            <ul className="block-options">
                                <li>
                                    <button type="button" onClick={() => setOpenLeaveAdjustmentModal()}>
                                        <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                                    </button>
                                </li>
                            </ul>
                            <h3 className="block-title">Add Leave Adjustment</h3>
                        </div>
                        <div className="block-content" style={{ padding: 20 }}>
                            <div className="col-sm-7" style={{ paddingBottom: 10, paddingLeft: 0 }}>
                                <div className=" form-material">
                                    <label htmlFor="material-text">Employee</label>
                                    <Select
                                        id="employee"
                                        value={employee}
                                        options={employeeOptions}
                                        onChange={setEmployee}
                                    />
                                </div>
                            </div>
                            <div className="col-sm-5" style={{ paddingRight: 0 }}>
                                <div className=" form-material">
                                    <label>Hours</label>
                                    <input id="hours-input" type="number"
                                        onChange={(e) => {
                                            setHoursWorked(e.target.value)
                                        }}
                                        className="form-input"
                                        style={{ width: "100%" }}
                                        value={hours} />
                                </div>
                            </div>
                            <div className="clearfix" />
                            {leaveTypeOptions &&
                                <div className="col-sm-6 pl-0" style={{ paddingBottom: 10 }}>
                                    <label htmlFor="material-text">Leave Type</label>
                                    <Select
                                        value={leaveType}
                                        options={leaveTypeOptions}
                                        onChange={setLeaveType}
                                    />
                                    <div className="clearfix" />
                                </div>
                            }
                            <div className="col-sm-6 pl-0" style={{ paddingRight: 0 }}>
                                <label htmlFor="material-text">Adjustment Type</label>
                                <Select
                                    id="type"
                                    value={type}
                                    options={typeOptions}
                                    onChange={setType}
                                />
                            </div>
                            <div className="clearfix" />
                            <div className="col-sm-5" style={{ paddingBottom: 10, paddingLeft: 0 }}>
                                <label>Date</label>
                                <DatePicker
                                    wrapperClassName="full-width"
                                    selected={leaveDate}
                                    onChange={(date) => setLeaveDate(date)}
                                    minDate={subYears(new Date(), 100)}
                                    maxDate={addYears(new Date(), 100)}
                                    dateFormat="dd/MM/yyyy"
                                    popperPlacement="bottom-start"
                                    customInput={<DateInputFormat />}
                                />
                            </div>
                            <div className="clearfix" />
                            <div className="col-sm-12 pl-0" style={{ paddingRight: 0 }}>
                                <label>Comment</label>
                                <textarea
                                    id="comment-box"
                                    className="full-width form-input"
                                    onChange={(e) => {
                                        setComment(e.target.value)
                                    }}
                                    style={{ minHeight: 100, maxHeight: 400, resize: "vertical" }}
                                    value={comment} />
                            </div>
                            <div className="clearfix" />
                            <div className="pull-right">
                                <div
                                    id="submit"
                                    className="btn btn-success pull-right"
                                    style={{
                                        marginTop: '15px',
                                        marginLeft: '5px',
                                    }}
                                    onClick={saveLeaveData}
                                >
                                    {isSaving
                                        ?
                                        <Spinner
                                            style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
                                            className="animate-spin -ml-1 mr-3 h-5 w-5 "
                                        />
                                        :
                                        `Submit`
                                    }
                                </div>
                                <div
                                    id="cancel"
                                    className="btn btn-default pull-right"
                                    style={{
                                        marginTop: '15px',
                                    }}
                                    onClick={() => setOpenLeaveAdjustmentModal()}
                                >
                                    Close
                                </div>
                            </div>
                            <div className="clearfix" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


const mapStateToProps = (state) => {
    let leaveTypes = state.leave.leaveTypes;

    const typeOptions = [
        {
            value: "Carryover",
            label: "Carryover",
        },
        {
            value: "TOIL",
            label: "TOIL",
        },
        {
            value: "Manual",
            label: "Manual",
        },
        {
            value: "Balance as at",
            label: "Balance as at"
        },
        {
            value: "Consumed",
            label: "Consumed"
        }
    ]

    const employeeListWithSalary = state && state.employees && state.employees.employeeListWithSalary

    const employeeOptions = employeeListWithSalary && employeeListWithSalary.map(employee => ({
        value: employee.id,
        label: `${employee.employeeName} ${employee.employeeSurname}`,
        employee
    }))

    const leaveTypeOptions = leaveTypes && leaveTypes.map(leaveType => ({
        value: leaveType.id,
        label: leaveType.name
    }))

    return {
        isSaving: state.leaveAdjustments.modalSaving,
        leaveTypes,
        leaveTypeOptions,
        typeOptions,
        modalAdjustmentState: state.leaveAdjustments.modalAdjustmentState,
        modalAdjustmentLeave: state.leaveAdjustments.modalAdjustmentLeave,
        employeeOptions,
    }
}

const mapDispatchToProps = dispatch => ({
    setOpenLeaveAdjustmentModal: () => dispatch(LEAVEADJUSTMENTACTIONS.setOpenLeaveAdjustmentModal(false)),
    saveLeaveAdjustments: (leave) => dispatch(LEAVEADJUSTMENTACTIONS.saveLeaveAdjustment(leave)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LeaveAdjustmentModal)